import { styled } from "linaria/react";
import React from "react";
import ReactMarkdown from "react-markdown";
import { theme } from "../Theme/Theme";

export interface ContentRendererProps {
  className?: string;
  source: string;
}

const ContentRendererInner = (props: ContentRendererProps) => {
  const { source } = props;
  return (
    <div className={props.className}>
      <ReactMarkdown escapeHtml={false} source={source} />
    </div>
  );
};

export const ContentRenderer = styled(ContentRendererInner)`
  p {
    margin-bottom: 3rem;
    color: ${theme.color.text}aliceblue;
    font-size: 1.8rem;
    font-weight: 300;
  }

  img {
    width: 50%;
    margin: auto;
    filter: drop-shadow(0px 6.60449px 16.5112px rgba(0, 0, 0, 0.2));
    border-radius: 4px;
    display: flex;
  }
`;
